module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/banner/vi-e020c07e75ea224f9da4806d13291e99.jpg";